export const DEFAULT_SESSION_LENGTH = 1500
export const DEFAULT_SESSION_NAME = 'Default session'

export const LOCAL_STORAGE_KEYS = {
  SETTINGS: 'SETTINGS_KEY',
  LAST_SESSION_ID: 'LAST_SESSION_ID',
  TIMER_STATE: 'TIMER_STATE',
}

export const SETTINGS_KEYS = {
  PLAY_SOUND: 'playSound',
}

export const INPUT_TYPES = {
  NUMBER: 'number',
  CHECKBOX: 'checkbox',
}
